import AppObjectOkButton from './AppObjectOkButton'
import AppObjectCancelButton from './AppObjectCancelButton'

export default function AppObjectActionButtons(props) {
  console.log('AppObjectActionButtons rendered', props)
  const { object, refListId, action } = props  

  return (
    <div>
      <span style={{ fontWeight: 'bold' }} data-cy='app-object-action-name'>{action.name} {object.type.name}</span>
      <AppObjectOkButton object={object} refListId={refListId} />
      <AppObjectCancelButton object={object} refListId={refListId} />
    </div>
  )
}
